import ATable, { ATableHeader } from '../../../../organisms/ATable';
import { Topology } from '../../../../../services/eventingApi';
import { useConsumerSearch } from '../hooks/useConsumerSearch';
import ConsumerSearch from '../shared/ConsumerSearch';
import SubscriptionsEmptyState from '../shared/SubscriptionsEmptyState';
import { Section } from '../shared/ui';
import SubscriptionRow from './SubscriptionRow';

const HEADER_CLASS = 'border-b px-2 text-left';

const HEADERS: ATableHeader[] = [
  { id: 'consumer', title: 'Consumidor', canSort: false, cssClass: HEADER_CLASS },
  { id: 'protocol', title: 'Protocolo', canSort: false, cssClass: HEADER_CLASS },
  { id: 'eventTypes', title: 'Tipos assinados', canSort: false, cssClass: HEADER_CLASS },
  { id: 'visible', title: 'Na fila', canSort: false, cssClass: HEADER_CLASS },
  { id: 'inFlight', title: 'Em processamento', canSort: false, cssClass: HEADER_CLASS },
  { id: 'deadLetter', title: 'DLQ', canSort: false, cssClass: HEADER_CLASS },
];

interface SubscriptionsCardProps {
  topology: Topology;
  onOpenConsumer: (consumer: string) => void;
}

const SubscriptionsCard = ({ topology, onOpenConsumer }: SubscriptionsCardProps) => {
  const { search, setSearch, visible } = useConsumerSearch(topology.subscriptions);

  return (
    <Section
      title="Assinaturas do tópico"
      subtitle={topology.topicArn}
      actions={<ConsumerSearch value={search} onChange={setSearch} />}
    >
      <SubscriptionsEmptyState total={topology.subscriptions.length} visible={visible.length} />
      {visible.length > 0 && (
        <div className="h-96 overflow-y-auto">
          <ATable headers={HEADERS}>
            {visible.map((subscription) => (
              <SubscriptionRow key={subscription.subscriptionArn} subscription={subscription} onOpenConsumer={onOpenConsumer} />
            ))}
          </ATable>
        </div>
      )}
    </Section>
  );
};

export default SubscriptionsCard;
